import e from "react";
const a = (t) => e.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 14 14", width: "14", height: "14" }, t),
  e.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    e.createElement(
      "g",
      null,
      e.createElement("path", { d: "M602.058002,18 L606.468163,13.5898393 C607.114964,12.9430385 607.181231,11.9507485 606.615163,11.3848367 C606.049252,10.8187694 605.056961,10.8850361 604.410161,11.5318369 L600,15.9419976 L595.589839,11.5318369 C594.943039,10.8850361 593.950748,10.8187694 593.384837,11.3848367 C592.818769,11.9507485 592.885036,12.9430385 593.531837,13.5898393 L597.941998,18 L593.531837,22.4101607 C592.885036,23.0569615 592.818769,24.0492515 593.384837,24.6151633 C593.950748,25.1812306 594.943039,25.1149639 595.589839,24.4681631 L600,20.0580024 L604.410161,24.4681631 C605.056961,25.1149639 606.049252,25.1812306 606.615163,24.6151633 C607.181231,24.0492515 607.114964,23.0569615 606.468163,22.4101607 L602.058002,18", transform: "translate(-593 -11)" })
    )
  )
);
a.displayName = "X14x14";
export {
  a as I
};
//# sourceMappingURL=X14x14-Dq3_cvuT.mjs.map
